var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#FFE361"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.048 22.25H41.0417C44.8156 22.25 47.875 25.3094 47.875 29.0833V41.0417C47.875 44.8156 44.8156 47.875 41.0417 47.875H28.2954C27.7171 47.875 27.1781 47.5824 26.863 47.0975C26.5479 46.6126 26.4995 46.0013 26.7344 45.4728L38.2658 19.5272C38.5007 18.9987 38.4522 18.3873 38.1371 17.9024C37.822 17.4175 37.2829 17.125 36.7046 17.125H23.9583C20.1844 17.125 17.125 20.1844 17.125 23.9583V35.9167C17.125 39.6906 20.1844 42.75 23.9583 42.75H27.9644",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4792 35.0625L41.0417 37.625L38.4792 40.1875",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5208 29.9375L23.9583 27.375L26.5208 24.8125",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logoCircle.8067f5998925c7a92fd81030b6777226.svg";
export { ForwardRef as ReactComponent };